module.exports = __webpack_public_path__ + "img/eita_icon.c8488cd4.png";